import React from 'react'
import { useStateValue } from "./StateProvider";
import "./CheckoutProduct.css"

function CheckoutProduct({ id, title, price, image, hideButton }) {
    const [{ basket }, dispatch] = useStateValue();

    const RemoveFromBasket = () => {
        dispatch({
            type: "REMOVE_FROM_BASKET",
            id: id,
            title: title,
            image: image,
            price: price,
        })
    }
    
    return (
        <div className="checkoutProduct">
            <img className="image" src={image} />
            <div className="info">
                <p className="title">{title}</p>
                <p className="price">
                    <small>$</small>
                    <strong>{price}</strong>
                </p>
                {! hideButton && (
                    <button onClick={RemoveFromBasket}>Remove From Basket</button>
                )}
            </div>
        </div>
    )
}

export default CheckoutProduct